import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function MedencePonyvak() {
  return (
    <SubPageLayout
      pageNumber="03"
      eyebrow="Medenceponyvák"
      title={
        <>
          Medencebélés és{" "}
          <span className="whitespace-nowrap">-takaró</span>{" "}
          – egy helyről.
        </>
      }
      intro="Bélés- (víztartó) és takaróponyva-gyártás, csere és felújítás. Standard Ø 3,6 m és Ø 4,5 m átmérőhöz csomagajánlatok."
      heroImage="/assets/gallery/medence.jpg"
      bullets={[
        { title: "Bélés ponyva", text: "Erős, vízálló PVC anyag, méretre szabva – tartós tömítettség." },
        { title: "Takaró ponyva", text: "Levél-, por- és UV-védelem a vízminőség megőrzéséhez." },
        { title: "Felújítás", text: "Meglévő ponyvatartó vázhoz új ponyva, hegesztéssel és átszereléssel." },
        { title: "Csomagajánlat", text: "Bélés + takaró együtt kedvezőbb feltételekkel, mint külön." },
      ]}
      gallery={SITE_IMAGES.poolGallery}
    />
  );
}
